import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataAvito: [],
  newAvito: null,
  activeAvito: localStorage.getItem("dataAvito")
    ? JSON.parse(localStorage.getItem("dataAvito"))
    : null,
  updateAvito: false,
  updateAvitoData: {},
  isLoading: false,
  isLoadingContent: false,
  isConnected: false,
  isErrorAvito: false,
};

const avitoSlice = createSlice({
  name: "avito",
  initialState,
  reducers: {
    setDataAvito(state, action) {
      state.dataAvito = action.payload;
    },
    setNewAvito(state, action) {
      state.newAvito = action.payload;
    },
    setActiveAvito(state, action) {
      state.activeAvito = action.payload;
    },
    setUpdateAvito(state, action) {
      state.updateAvito = action.payload;
    },
    setUpdateAvitoData(state, action) {
      state.updateAvitoData = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsLoadingContent(state, action) {
      state.isLoadingContent = action.payload;
    },
    setIsConnected(state, action) {
      state.isConnected = action.payload;
    },
    setIsErrorAvito(state, action) {
      state.isErrorAvito = action.payload;
    },
  },
});

export const {
  setDataAvito,
  setNewAvito,
  setActiveAvito,
  setUpdateAvito,
  setUpdateAvitoData,
  setIsLoading,
  setIsLoadingContent,
  setIsConnected,
  setIsErrorAvito,
} = avitoSlice.actions;

export default avitoSlice.reducer;
